export default {
  lpbDashboard: {
    filterPanel: {
      containerPadding: '0 16px',
      linksAligment: 'center',
    },
    tile: {
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
      boxShadowHover: '0 8px 16px 0 rgba(0, 0, 0, 0.1), 0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    },
    colors: {
      bg: '#ecf0f8',
      tileOverlayBg: '#4c93e680',
      tileOverlayLink: '#3b73b3',
      tileAbbrText: '#3b73b3',
      filterBg: '#fff',
      filterLinkActive: '#3b73b3',
      filterBorder: '#e6e6e6',
      filterLinkColor: '#999',
      filterArrowsBg: '#fff',
      filterArrowColor: '#ccc',
      fallbackMsgColor: '#999',
      pageNotFoundBg: '#f5f7fa',
      tileArrowsBg: '#fff',
      tileLinkBg: '#fff',
      tileImgBoxBg: '#fff',
      tileImgBoxBorder: '#e4ecf5',
      tileTitleColor: '#333',
      tileDescriptionColor: '#808080',
    },
  },
};
